import api from "./Api";

class TransportadoraTelefoneService {
  GetTransportadoraTelefone(payload) {
    return api.get("/v1/transportadoraTelefone/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTransportadoraTelefone(payload) {
    return api.post("/v1/transportadoraTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  PutTransportadoraTelefone(payload) {
    return api.put("/v1/transportadoraTelefone/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTransportadoraTelefone(payload) {
    return api
      .delete("/v1/transportadoraTelefone/" + payload)
      .then((response) => {
        return response.data;
      });
  }

  GetTransportadoraTelefoneOData(payload) {
    return api
      .get("/OData/TransportadoraTelefone" + payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new TransportadoraTelefoneService();
